import { render } from "./matchSelector.vue?vue&type=template&id=30e67332&ts=true"
import script from "./matchSelector.vue?vue&type=script&lang=ts"
export * from "./matchSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__